module.exports = Object.freeze({
  'res': `{
  "data": [
    {
      "date": "2023-03-31",
      "value": 385095000000
    },
    {
      "date": "2022-12-31",
      "value": 387537000000
    },
    {
      "date": "2022-09-30",
      "value": 394328000000
    },
    {
      "date": "2022-06-30",
      "value": 387542000000
    },
    {
      "date": "2022-03-31",
      "value": 386017000000
    },
    {
      "date": "2021-12-31",
      "value": 378323000000
    },
    {
      "date": "2021-09-30",
      "value": 365817000000
    },
    {
      "date": "2021-06-30",
      "value": 347155000000
    },
    {
      "date": "2021-03-31",
      "value": 325406000000
    },
    {
      "date": "2020-12-31",
      "value": 294135000000
    },
    {
      "date": "2020-09-30",
      "value": 274515000000
    },
    {
      "date": "2020-06-30",
      "value": 273857000000
    },
    {
      "date": "2020-03-31",
      "value": 267981000000
    },
    {
      "date": "2019-12-31",
      "value": 267683000000
    },
    {
      "date": "2019-09-30",
      "value": 260174000000
    },
    {
      "date": "2019-06-30",
      "value": 259034000000
    },
    {
      "date": "2019-03-31",
      "value": 258490000000
    },
    {
      "date": "2018-12-31",
      "value": 261612000000
    },
    {
      "date": "2018-09-30",
      "value": 265595000000
    },
    {
      "date": "2018-06-30",
      "value": 255274000000
    },
    {
      "date": "2018-03-31",
      "value": 247417000000
    },
    {
      "date": "2017-12-31",
      "value": 239176000000
    },
    {
      "date": "2017-09-30",
      "value": 229234000000
    },
    {
      "date": "2017-06-30",
      "value": 223507000000
    },
    {
      "date": "2017-03-31",
      "value": 220457000000
    },
    {
      "date": "2016-12-31",
      "value": 218118000000
    },
    {
      "date": "2016-09-30",
      "value": 215639000000
    },
    {
      "date": "2016-06-30",
      "value": 220288000000
    },
    {
      "date": "2016-03-31",
      "value": 227535000000
    },
    {
      "date": "2015-12-31",
      "value": 234988000000
    },
    {
      "date": "2015-09-30",
      "value": 233715000000
    },
    {
      "date": "2015-06-30",
      "value": 224337000000
    },
    {
      "date": "2015-03-31",
      "value": 212164000000
    },
    {
      "date": "2014-12-31",
      "value": 199800000000
    },
    {
      "date": "2014-09-30",
      "value": 182795000000
    },
    {
      "date": "2014-06-30",
      "value": 178144000000
    },
    {
      "date": "2014-03-31",
      "value": 176035000000
    },
    {
      "date": "2013-12-31",
      "value": 173992000000
    },
    {
      "date": "2013-09-30",
      "value": 170910000000
    },
    {
      "date": "2013-06-30",
      "value": 169404000000
    },
    {
      "date": "2013-03-31",
      "value": 169104000000
    },
    {
      "date": "2012-12-31",
      "value": 164687000000
    },
    {
      "date": "2012-09-30",
      "value": 156508000000
    },
    {
      "date": "2012-06-30",
      "value": 148812000000
    },
    {
      "date": "2012-03-31",
      "value": 142360000000
    },
    {
      "date": "2011-12-31",
      "value": 127841000000
    },
    {
      "date": "2011-09-30",
      "value": 108249000000
    },
    {
      "date": "2011-06-30",
      "value": 100322000000
    },
    {
      "date": "2011-03-31",
      "value": 87451000000
    },
    {
      "date": "2010-12-31",
      "value": 76283000000
    },
    {
      "date": "2010-09-30",
      "value": 65225000000
    },
    {
      "date": "2010-06-30",
      "value": 57089000000
    },
    {
      "date": "2010-03-31",
      "value": 51123000000
    },
    {
      "date": "2009-12-31",
      "value": 46708000000
    },
    {
      "date": "2009-09-30",
      "value": 42905000000
    },
    {
      "date": "2009-06-30",
      "value": 43605000000
    },
    {
      "date": "2009-03-31",
      "value": 41335000000
    },
    {
      "date": "2008-12-31",
      "value": 43001333333.3333
    },
    {
      "date": "2008-09-30",
      "value": 37491000000
    },
    {
      "date": "2008-06-30",
      "value": 29856000000
    },
    {
      "date": "2007-09-30",
      "value": 24578000000
    }
  ]
}`,
});
